import Icon from '../components/Icon.vue'

Icon.register({
  'grin-hearts': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM90.4 183.6c-7.7 20.2 3.8 41.8 24.2 47.2l70.2 18.2c4.6 1.2 9.3-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.7-3-36.5 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.8-38.2 4.3-44.9 21.9zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.3-21.5-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.5-3.6-22.7 6.1-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3zM381.4 230.7c20.4-5.3 31.9-26.9 24.2-47.2-6.7-17.6-26.7-26.6-44.9-21.9l-7.1 1.9-2-7.1c-5.1-18.1-22.9-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.3 4.5 6 7.2 10.5 6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-hearts.js
// module id = 1405
// module chunks = 0